import { createFileRoute } from "@tanstack/react-router";
import { WaTemplatesPage } from "@/features/watemplates/WaTemplatesPage";

/** WhatsApp Cloud API message templates, opt-ins and broadcasts (X4-03). */
export const Route = createFileRoute("/_app/inbox/whatsapp-templates")({
  component: WaTemplatesPage,
});
